import { render } from "./AuraProcessingCostsSummary.vue?vue&type=template&id=646bb1c8&ts=true"
import script from "./AuraProcessingCostsSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraProcessingCostsSummary.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/AuraProcessingCostsSummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "646bb1c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('646bb1c8', __exports__)) {
    api.reload('646bb1c8', __exports__)
  }
  
  module.hot.accept("./AuraProcessingCostsSummary.vue?vue&type=template&id=646bb1c8&ts=true", () => {
    api.rerender('646bb1c8', render)
  })

}


export default __exports__